module.exports = __webpack_public_path__ + "cbec8bf522cd05773cc01b599168e49a.fbx";